import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

function CustomBox({ children, className, ...props }: React.ComponentProps<'div'>) {
    return (
        <div className={cn('p-6 pb-4', className)} {...props}>
            {children}
        </div>
    );
}

export default CustomBox;
